import React from 'react'
import { Opportunity } from 'Types'
import { useStoreState } from 'Store'
import { UropAlert, UROP_THEME_ID } from 'Components/alert/UropAlert'

interface Props {
  opportunity: Opportunity
  title: string
  isLoading: boolean
}

export const ExperienceDetailHeader: React.FC<Props> = ({ opportunity, title, isLoading }) => {
  const { lookupItems } = useStoreState(state => state.filterModel)

  if (isLoading) return null

  const isUropTheme = (theme?: { id?: string | number }): boolean => Number(theme?.id) === UROP_THEME_ID
  const isUrop = isUropTheme(opportunity?.primary_theme) || (opportunity?.themes ?? []).some(isUropTheme)

  return (
    <>
      <br />
      <UropAlert
        is_urop={isUrop}
        sponsor_funded_deadline={lookupItems?.urop_deadlines?.sponsor_funded_deadline ?? ''}
        urop_funded_deadline={lookupItems?.urop_deadlines?.urop_funded_deadline ?? ''}
        term={lookupItems?.urop_deadlines?.term ?? ''}
      />

      <div className='opportunity-list-header'>
        <h4>{title}</h4>
      </div>
    </>
  )
}
